import { $GQL } from '@GQL/index';

export async function getParentAccounts() {
	const query = `
    query GetParentAccounts {
        parentAccounts {
          id
          name
        }
      }`;

	return (await $GQL.request(query, { no_cache: ['parentAccounts'] })).parentAccounts;
}
